"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

require("./styles.css");

var _Loader = _interopRequireDefault(require("../Loader"));

var _Cropper = _interopRequireDefault(require("../Cropper"));

var _InViewport = require("../InViewport");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MHubImage =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(MHubImage, _PureComponent);

  _createClass(MHubImage, null, [{
    key: "s3File",
    value: function s3File(src, _ref) {
      var bucket = _ref.bucket,
          region = _ref.region;
      return "https://s3-".concat(region, ".amazonaws.com/").concat(bucket, "/").concat(src);
    }
  }]);

  function MHubImage(props) {
    var _this;

    _classCallCheck(this, MHubImage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MHubImage).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var propNames = ['fluid', 'disabled', 'inverted'];
      var names = [MHubImage.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      (0, _lib.addClassByPropName)(names, _this.state, ['loaded']);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "load", function () {
      var loaded = _this.state.loaded;

      if (!loaded) {
        _this.setState({
          loading: true
        }, function () {
          var image = new Image();
          var src = _this.props.src;
          image.src = src;

          if (image.complete) {
            image.loaded = true;

            _this.handleOnLoad();
          } else {
            image.onload = _this.handleOnLoad;
            image.onerror = _this.handleOnError;
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnLoad", function (e) {
      _this.setState({
        loaded: true,
        loading: false
      }, function () {
        var onLoad = _this.props.onLoad;

        if (onLoad) {
          onLoad(e);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnError", function (e) {
      _this.setState({
        loading: false
      }, function () {
        var onError = _this.props.onError;

        if (onError) {
          onError(e);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled;
      (0, _lib.callEventMethods)(e, 'persist');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props2 = _this.props,
          innerRef = _this$props2.innerRef,
          loaderNode = _this$props2.loaderNode,
          emptyNode = _this$props2.emptyNode,
          alt = _this$props2.alt,
          src = _this$props2.src,
          children = _this$props2.children;
      var _this$state = _this.state,
          loaded = _this$state.loaded,
          loading = _this$state.loading;

      if (loaded) {
        var ref = innerRef || _this.innerRef;
        return (0, _lib.getRenderProps)(children, {
          ref: ref,
          src: src,
          alt: alt
        });
      }

      return _react.default.createElement("span", {
        className: "placeholder"
      }, loading ? loaderNode : emptyNode);
    });

    var _src = props.src,
        _loading = props.loading;
    _this.state = {
      prevProps: {
        src: _src,
        loading: _loading
      },
      loaded: false,
      loading: _loading
    };
    _this.innerRef = _react.default.createRef();
    return _this;
  }

  _createClass(MHubImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var visible = this.props.visible;

      if (visible) {
        this.load();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          src = _this$props3.src,
          visible = _this$props3.visible;

      if (src && src !== prevProps.src || visible && visible !== prevProps.visible) {
        this.load();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          as = _this$props4.as,
          className = _this$props4.className,
          innerRef = _this$props4.innerRef,
          wrapperRef = _this$props4.wrapperRef,
          loaderNode = _this$props4.loaderNode,
          emptyNode = _this$props4.emptyNode,
          alt = _this$props4.alt,
          fluid = _this$props4.fluid,
          onLoad = _this$props4.onLoad,
          onError = _this$props4.onError,
          visible = _this$props4.visible,
          src = _this$props4.src,
          loading = _this$props4.loading,
          inverted = _this$props4.inverted,
          rest = _objectWithoutProperties(_this$props4, ["as", "className", "innerRef", "wrapperRef", "loaderNode", "emptyNode", "alt", "fluid", "onLoad", "onError", "visible", "src", "loading", "inverted"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      return _react.default.createElement(Wrapper, _extends({}, rest, {
        ref: wrapperRef,
        className: classNames,
        onClick: this.handleOnClick
      }), this.renderContent());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var src = props.src,
          loading = props.loading;
      return {
        // Store the previous props in state
        prevProps: {
          src: src,
          loading: loading
        },
        loaded: prevProps.src === src && state.loaded,
        loading: prevProps.loading !== loading ? loading : state.loading
      };
    }
  }]);

  return MHubImage;
}(_react.PureComponent);

exports.default = MHubImage;

_defineProperty(MHubImage, "InView", (0, _InViewport.withinViewport)(MHubImage));

_defineProperty(MHubImage, "Crop", _Cropper.default);

_defineProperty(MHubImage, "className", 'MHub-Image');

_defineProperty(MHubImage, "displayName", 'Image');

_defineProperty(MHubImage, "propTypes", {
  as: _common.customPropTypes.as,
  children: _common.customPropTypes.render,
  className: _propTypes.default.string,
  src: _propTypes.default.string,
  alt: _propTypes.default.string,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  fluid: _propTypes.default.bool,
  innerRef: _common.customPropTypes.ref,
  wrapperRef: _common.customPropTypes.ref,
  emptyNode: _propTypes.default.node,
  loaderNode: _propTypes.default.node,
  onLoad: _propTypes.default.func,
  onError: _propTypes.default.func,
  visible: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  inverted: _propTypes.default.bool
});

_defineProperty(MHubImage, "defaultProps", {
  as: null,
  children: function children(_ref2) {
    var ref = _ref2.ref,
        src = _ref2.src,
        alt = _ref2.alt;
    return _react.default.createElement("img", {
      ref: ref,
      src: src,
      alt: alt
    });
  },
  className: null,
  src: null,
  alt: 'Image',
  fluid: false,
  onClick: null,
  disabled: false,
  innerRef: null,
  wrapperRef: null,
  emptyNode: _react.default.createElement("p", null, "No image"),
  // TODO: image icon
  loaderNode: _react.default.createElement(_Loader.default, {
    color: "grey"
  }),
  onLoad: null,
  onError: null,
  visible: true,
  loading: false,
  inverted: false
});